module.exports = "<svg viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.5 8.5l7.3 7.3c.27.27.27.72 0 1-.15.13-.33.2-.5.2-.2 0-.37-.07-.5-.2L8.5 9.5l-7.3 7.3c-.13.13-.3.2-.5.2-.17 0-.35-.07-.5-.2-.27-.28-.27-.73 0-1l7.3-7.3L.2 1.2C-.06.94-.06.5.2.2c.28-.27.73-.27 1 0l7.3 7.3L15.8.2c.27-.27.72-.27 1 0 .27.28.27.73 0 1L9.5 8.5z\" stroke-width=\".25\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/onboarding/close.svg
// module id = fIl0
// module chunks = 89